export default "__VITE_ASSET__DXo4gXT$__"